/** Which corrections make sense for the current eye, and what a selection falls back to (SPEC visibility rules, D-019, D-021). */

import { baseCorrection, isToric, type CorrectionId } from './profile';

export interface AvailabilityInput {
  age: number;
  /** Cylinder as entered (either sign); 0 = no astigmatism. */
  cyl: number;
  keratoconus: number;
  aphakia: boolean;
}

export function isAvailable(id: CorrectionId, s: AvailabilityInput): boolean {
  const base = baseCorrection(id);
  // Expert feedback: without astigmatism the toric versions are not offered.
  if (isToric(id) && s.cyl === 0) return false;
  if (base === 'progressive') return s.age >= 40 || s.aphakia;
  if (base === 'rgp') return s.keratoconus > 0 || s.aphakia;
  // A phakic lens sits in front of the natural lens, so it needs one.
  if (base === 'icl') return !s.aphakia;
  return true;
}

export function availableCorrections(ids: readonly CorrectionId[], s: AvailabilityInput): CorrectionId[] {
  return ids.filter((id) => isAvailable(id, s));
}

/** Replacement for a selection that stopped being available: its non-toric version, otherwise glasses. */
export function normalizeCorrection(id: CorrectionId, s: AvailabilityInput): CorrectionId {
  if (isAvailable(id, s)) return id;
  const base = baseCorrection(id);
  if (base !== id && isAvailable(base, s)) return base;
  return 'glasses';
}
